<template>
  <router-link class="breadcrumb-item" :to="info.to">
    {{ info.title }}
  </router-link>
</template>

<script>
export default {
  name: "AppBreadcrumbsItem",
  props: {
    crumb: {
      type: [Object, Function],
      required: true
    }
  },
  computed: {
    info() {
      const { crumb } = this;
      return typeof crumb === "function" ? crumb() : crumb;
    }
  }
};
</script>

<style lang="scss">
.breadcrumb-item {
  color: colors(text-2);
  font-weight: fw(bold);
  text-shadow: 0 0 5px colors(palette-5);
  &:hover {
    text-decoration: none;
    color: colors(text-4);
  }
  &:active {
    color: colors(text-4);
  }
  &:not(:last-child) {
    &::after {
      content: ">";
      color: colors(text-4);
      margin: 0 10px;
    }
  }

  &:last-child {
    pointer-events: none;
  }
}
</style>
